export const generateTaskCost = (data: { unitPrice: number; count?: number }) => {
  const { count = 1, unitPrice } = data;
  return unitPrice * count;
};

export type GeneratePriceProps = {
  size: { w: number; h: number };
  unitPrice?: number;
  baseSize?: { w: number; h: number };
  basePrice?: number;
  fixPrice?: number;
};
export const progressPriceGenerator = (params: GeneratePriceProps) => {
  const { size, unitPrice, basePrice, baseSize, fixPrice } = params;
  const _baseSize = baseSize ?? { w: 512, h: 704 };
  const scale = (size.w * size.h) / (_baseSize.w * _baseSize.h);
  return (
    fixPrice ??
    (typeof unitPrice === "number"
      ? Math.round(Math.max(1, scale) * unitPrice + (basePrice ?? 0))
      : basePrice ?? 0)
  );
};
